import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { LoadingSpinner } from './loading-spinner';
import { LeafTreeItem } from './leaf-tree-item';
import { LOADING_CELL } from '../utils';

export const SubTreeItem = ({
  folderItem,
  level,
  setSize,
  posinset,
  classes,
  selectedItemId,
  onRenderSubTree,
  onLeafTreeItemClicked,
  loadMoreFolderPathTreeItem,
  parentFolder,
  onDrop,
}) => {
  const loadMore = useCallback(() => {
    loadMoreFolderPathTreeItem(parentFolder.folderId, parentFolder.subFolders.length);
  }, [loadMoreFolderPathTreeItem, parentFolder.folderId, parentFolder.subFolders.length]);

  if (folderItem === LOADING_CELL) {
    return <LoadingSpinner onLoading={loadMore} />;
  }
  if (folderItem.subFoldersCount > 0) {
    return onRenderSubTree(folderItem);
  }
  return (
    <LeafTreeItem
      value={folderItem.folderId}
      level={level}
      setSize={setSize}
      posinset={posinset}
      key={folderItem.folderId}
      onClick={onLeafTreeItemClicked}
      classes={classes}
      isSelected={selectedItemId === folderItem.folderId}
      content={folderItem.folderName}
      parentValue={parentFolder.folderId}
      onDrop={onDrop}
    />
  );
};

SubTreeItem.propTypes = {
  folderItem: PropTypes.shape({
    folderId: PropTypes.number,
    folderName: PropTypes.string,
    subFoldersCount: PropTypes.number,
  }).isRequired,
  level: PropTypes.number.isRequired,
  setSize: PropTypes.number.isRequired,
  posinset: PropTypes.number.isRequired,
  classes: PropTypes.shape({
    treeItemLayout: PropTypes.string,
    treeSelected: PropTypes.string,
  }).isRequired,
  onRenderSubTree: PropTypes.func.isRequired,
  onLeafTreeItemClicked: PropTypes.func.isRequired,
  loadMoreFolderPathTreeItem: PropTypes.func.isRequired,
  parentFolder: PropTypes.shape({
    folderId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    subFolders: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  selectedItemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onDrop: PropTypes.func.isRequired,
};

SubTreeItem.defaultProps = {
  selectedItemId: null,
};
